import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

export enum ModalTypes {
  SearchHistory = 'search-history',
  SearchDocuments = 'search-documents',
  AddAssets = 'add-assets',
  AddCondition = 'add-condition',
  CurrencySelection = 'currency-selection',
  DisconnectPortfolio = 'disconnect-portfolio',
  SetAlias = 'set-alias',
  CancelSubscription = 'cancel-subscription',
  Resubscribe = 'resubscribe',
  ChangeLocation = 'change-location',
  PasswordChange = 'password-change',
  ForgotPassword = 'forgot-password',
  EditPayment = 'edit-payment',
  RemoveCard = 'remove-card',
  Checkout = 'checkout',
}

export const useModal = (modalType: ModalTypes) => {
  const { setQueryParams, deleteQueryParam, params } = useQueryParams();

  const open = () => {
    setQueryParams({
      [queryKeys.activeModal]: modalType,
    });
  };

  const close = () => {
    deleteQueryParam(queryKeys.activeModal);
  };

  return {
    open,
    close,
    isOpen: params.activeModal === modalType,
  };
};
